import type { CSSProperties, ReactNode } from "react";

type RuntimeModalHeightAttributes = { style: CSSProperties };

type RuntimeModalHeightProps = {
  height?: number;
  children: (attributes: RuntimeModalHeightAttributes) => ReactNode;
};

/** Applies an optional caller-defined modal height while preserving the modal viewport constraint. */
export function RuntimeModalHeight({ height, children }: RuntimeModalHeightProps): ReactNode {
  return children({ style: { height: height ? height : "100%", maxHeight: "inherit" } });
}
